import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { AuthContext } from "../App";
import { getUserRole } from "./utilities/getUserRole";
import { FiUser, FiSettings, FiLogOut, FiChevronDown, FiLock, FiRefreshCw, FiMenu, FiX } from "react-icons/fi";
import { MdAdminPanelSettings } from "react-icons/md";
import { IoMdLock } from "react-icons/io";
import { BsUnlockFill } from "react-icons/bs";
import axios from "axios";
import { useToast } from '@chakra-ui/react';
import { useSidebar } from "./Layout";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toggle: toggleSidebar } = useSidebar();
  const { logout } = useContext(AuthContext) || {};
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toast = useToast();

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
  });
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const user = getUserRole();
  const userRole = user?.role || "admin";
  const userName = user?.fullName || user?.email || "User";
  const userEmail = user?.email || "";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setUserDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const onEsc = (e) => {
      if (e.key === "Escape") {
        setShowPasswordModal(false);
        setUserDropdownOpen(false);
      }
    };
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, []);

  const handleLogout = () => {
    if (logout) logout();
    navigate("/login");
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      if (passwordData.newPassword !== confirmPassword) {
        toast({
          title: "New Password and Confirm Password do not match!",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      await axios.put(
        `/api/v1/adminManagment/admins-change-password`,
        passwordData
      );
      toast({
        title: "Password updated successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setShowPasswordModal(false);
      setPasswordData({ currentPassword: "", newPassword: "" });
      setConfirmPassword("");
    } catch (error) {
      console.error(error);
      const message = error.response?.data?.message || "Error updating password";
      toast({
        title: message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const closePasswordModal = () => {
    setShowPasswordModal(false);
    setPasswordData({ currentPassword: "", newPassword: "" });
    setConfirmPassword("");
  };

  const isSuperAdmin = userRole === "super-admin";

  return (
    <header
      className="fixed top-0 right-0 h-16 z-40 flex items-center justify-between px-4 sm:px-6 header-full lg:left-72"
      style={{
        background: "linear-gradient(180deg, rgba(13,7,48,0.96), rgba(13,7,48,0.85))",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        borderBottom: "1px solid rgba(139,92,246,0.2)",
        boxShadow: "0 4px 24px rgba(0,0,0,0.35)",
      }}
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <button
          onClick={toggleSidebar}
          className="lg:hidden btn-icon-sm btn-ghost"
          aria-label="Toggle menu"
        >
          <FiMenu className="text-lg" />
        </button>
        <div className="hidden sm:flex items-center gap-2.5 min-w-0">
          {/* <span className="w-2 h-2 rounded-full" style={{ background: "#ec4899", boxShadow: "0 0 10px rgba(236,72,153,0.8)" }} />
          <span className="font-semibold tracking-wide text-sm" style={{ color: "#e9d5ff" }}>Cockroach</span> */}
          {/* <span className="text-xs" style={{ color: "#8e83ad" }}>Admin Panel</span> */}
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <button
          onClick={() => window.location.reload()}
          className="relative overflow-hidden flex items-center gap-2 px-3 sm:px-4 py-2 rounded-xl transition-all duration-200 text-sm"
          style={{
            background: "rgba(28,20,69,0.75)",
            border: "1px solid rgba(139,92,246,0.25)",
            color: "#e9d5ff",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(37,26,90,0.95)";
            e.currentTarget.style.borderColor = "rgba(236,72,153,0.45)";
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(139,92,246,0.2)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(28,20,69,0.75)";
            e.currentTarget.style.borderColor = "rgba(139,92,246,0.25)";
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
          title="Refresh Page"
        >
          <FiRefreshCw className="text-base" />
          <span className="font-medium hidden sm:inline">Refresh</span>
        </button>

        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setUserDropdownOpen(!userDropdownOpen)}
            className="relative overflow-hidden flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-1.5 rounded-xl transition-all duration-200"
            style={{
              background: "rgba(28,20,69,0.75)",
              border: "1px solid rgba(139,92,246,0.25)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(37,26,90,0.95)";
              e.currentTarget.style.borderColor = "rgba(236,72,153,0.45)";
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(139,92,246,0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(28,20,69,0.75)";
              e.currentTarget.style.borderColor = "rgba(139,92,246,0.25)";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <div
              className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
              style={{
                background: "linear-gradient(135deg, #a855f7, #ec4899)",
                boxShadow: "inset 0 1px 0 rgba(255,255,255,0.25), 0 3px 8px rgba(0,0,0,0.25)",
              }}
            >
              <FiUser className="text-white text-base" />
            </div>
            <div className="text-left hidden md:block leading-tight">
              <p className="text-sm font-semibold text-white">{userName}</p>
              <p className="text-[11px] capitalize" style={{ color: "#c084fc" }}>{userRole}</p>
            </div>
            <FiChevronDown
              className={`transition-transform duration-200 hidden sm:block ${userDropdownOpen ? "rotate-180" : ""}`}
              style={{ color: "#bdb2d7" }}
            />
          </button>

          {userDropdownOpen && (
            <div
              className="absolute right-0 mt-2 w-72 rounded-2xl z-50 overflow-hidden"
              style={{
                background: "linear-gradient(180deg, #17103d, #120c30)",
                border: "1px solid rgba(139,92,246,0.35)",
                boxShadow: "0 20px 48px rgba(0,0,0,0.55), 0 0 0 1px rgba(168,85,247,0.06)",
                backdropFilter: "blur(10px)",
                animation: "modalIn 0.18s cubic-bezier(0.16,1,0.3,1)",
              }}
            >
              <div className="px-5 py-4" style={{ borderBottom: "1px solid rgba(139,92,246,0.18)", background: "rgba(19,13,55,0.6)" }}>
                <div className="flex items-center gap-3">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{
                      background: "linear-gradient(135deg, #a855f7, #ec4899)",
                      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.25), 0 4px 12px rgba(168,85,247,0.3)",
                    }}
                  >
                    <FiUser className="text-white text-xl" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="font-semibold truncate" style={{ color: "#e9d5ff" }}>{userName}</p>
                    <p className="text-xs truncate" style={{ color: "#8e83ad" }}>{userEmail}</p>
                    <p className="text-xs mt-1 badge badge-primary inline-flex">Role: {userRole}</p>
                  </div>
                </div>
              </div>

              <div className="py-2">
                {isSuperAdmin && (
                  <>
                    <Link
                      to="/admin-managment"
                      onClick={() => setUserDropdownOpen(false)}
                      className={`flex items-center gap-3 px-5 py-2.5 text-sm transition-all ${
                        location.pathname === "/admin-managment" ? "" : ""
                      }`}
                      style={
                        location.pathname === "/admin-managment"
                          ? { background: "linear-gradient(135deg, rgba(168,85,247,0.95), rgba(236,72,153,0.9))", color: "white" }
                          : { color: "#e9d5ff" }
                      }
                      onMouseEnter={(e) => { if (location.pathname !== "/admin-managment") e.currentTarget.style.background = "rgba(168,85,247,0.1)"; }}
                      onMouseLeave={(e) => { if (location.pathname !== "/admin-managment") e.currentTarget.style.background = "transparent"; }}
                    >
                      <MdAdminPanelSettings className="text-lg" />
                      <span>Employee Management</span>
                    </Link>

                    <Link
                      to="/settings"
                      onClick={() => setUserDropdownOpen(false)}
                      className="flex items-center gap-3 px-5 py-2.5 text-sm transition-all"
                      style={
                        location.pathname === "/settings"
                          ? { background: "linear-gradient(135deg, rgba(168,85,247,0.95), rgba(236,72,153,0.9))", color: "white" }
                          : { color: "#e9d5ff" }
                      }
                      onMouseEnter={(e) => { if (location.pathname !== "/settings") e.currentTarget.style.background = "rgba(168,85,247,0.1)"; }}
                      onMouseLeave={(e) => { if (location.pathname !== "/settings") e.currentTarget.style.background = "transparent"; }}
                    >
                      <FiSettings className="text-lg" />
                      <span>Settings</span>
                    </Link>
                  </>
                )}

                <button
                  onClick={() => {
                    setShowPasswordModal(true);
                    setUserDropdownOpen(false);
                  }}
                  className="w-full flex items-center gap-3 px-5 py-2.5 text-sm transition-all text-left"
                  style={{ color: "#e9d5ff" }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "rgba(168,85,247,0.1)"}
                  onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                >
                  <FiLock className="text-lg" />
                  <span>Password Update</span>
                </button>

                <div className="my-1 mx-4" style={{ borderTop: "1px dashed rgba(139,92,246,0.2)" }} />

                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-3 px-5 py-2.5 text-sm transition-all text-left"
                  style={{ color: "#f87171" }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "rgba(239,68,68,0.1)"}
                  onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                >
                  <FiLogOut className="text-lg" />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Password Update Modal */}
      {showPasswordModal && (
        <>
          <div
            className="fixed inset-0 z-[100]"
            style={{ background: "rgba(5,3,20,0.75)", backdropFilter: "blur(6px)", animation: "fadeIn 0.15s ease-out" }}
            onClick={closePasswordModal}
          />
          <div className="fixed inset-0 flex justify-center items-center z-[100] p-4">
            <div
              className="w-full max-w-md rounded-2xl overflow-hidden"
              style={{
                background: "linear-gradient(180deg, #17103d, #120c30)",
                border: "1px solid rgba(139,92,246,0.35)",
                boxShadow: "0 24px 80px rgba(0,0,0,0.7), 0 0 0 1px rgba(168,85,247,0.06)",
                animation: "modalIn 0.25s cubic-bezier(0.16,1,0.3,1)",
              }}
            >
              <div className="flex items-center justify-between px-6 py-4" style={{ borderBottom: "1px solid rgba(139,92,246,0.2)" }}>
                <h3 className="txt-h3 m-0" style={{ fontSize: "1.15rem", margin: 0 }}>Change Password</h3>
                <button onClick={closePasswordModal} className="btn-icon-sm btn-ghost" aria-label="Close">
                  <FiX />
                </button>
              </div>

              <form onSubmit={handlePasswordSubmit} className="space-y-5 px-6 py-5">
                {/* CURRENT PASSWORD */}
                <div>
                  <label className="form-label">Current Password</label>
                  <div className="relative">
                    <input
                      type={showCurrent ? "text" : "password"}
                      name="currentPassword"
                      value={passwordData.currentPassword}
                      onChange={(e) => setPasswordData({ ...passwordData, currentPassword: e.target.value })}
                      required
                      className="input"
                    />
                    <span
                      onClick={() => setShowCurrent(!showCurrent)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
                      style={{ color: "#a855f7" }}
                    >
                      {showCurrent ? <BsUnlockFill className="text-lg" /> : <IoMdLock className="text-lg" />}
                    </span>
                  </div>
                </div>

                {/* NEW PASSWORD */}
                <div>
                  <label className="form-label">New Password</label>
                  <div className="relative">
                    <input
                      type={showNew ? "text" : "password"}
                      name="newPassword"
                      value={passwordData.newPassword}
                      onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
                      required
                      className="input"
                    />
                    <span
                      onClick={() => setShowNew(!showNew)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
                      style={{ color: "#a855f7" }}
                    >
                      {showNew ? <BsUnlockFill className="text-lg" /> : <IoMdLock className="text-lg" />}
                    </span>
                  </div>
                </div>

                {/* CONFIRM PASSWORD */}
                <div>
                  <label className="form-label">Confirm New Password</label>
                  <div className="relative">
                    <input
                      type={showConfirm ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      className="input"
                    />
                    <span
                      onClick={() => setShowConfirm(!showConfirm)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
                      style={{ color: "#a855f7" }}
                    >
                      {showConfirm ? <BsUnlockFill className="text-lg" /> : <IoMdLock className="text-lg" />}
                    </span>
                  </div>
                </div>

                <div className="flex justify-end gap-3 pt-2">
                  <button
                    type="button"
                    onClick={closePasswordModal}
                    className="btn btn-secondary"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                  >
                    Update Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
